import ContentAdminV2 from './ContentAdminV2'

export default ContentAdminV2
